import { AV } from './av';
import { Sfu } from './sfu';
import { SFU_KINDS } from '../../../../shared/protocol';
import { WANT } from '../../../3-store/meeting/links';
import { sendPolicy } from '../../../2-controllers/meeting/links';
import { heard } from '../../../2-controllers/meeting/classroom';

// 영상·송출을 컨트롤러가 3-store(meeting/links.ts)에 정해 둔 원하는 상태에 맞춘다. 프레임마다 부른다(presence.ts)
export function syncMedia() {
  const s = WANT.sfu, ids = WANT.peers;
  WANT.sfu = WANT.peers = null;
  if (s) {
    if (!s.on) { if (Sfu.active) Sfu.stop(); }   // 학교 밖에서는 서버 송출을 쓰지 않는다
    else if (!Sfu.dead) {
      Sfu.setSend(Object.fromEntries(SFU_KINDS.map((k) => [k, s.may.includes(k) ? AV.localTrack(k) : null])));
      Sfu.setRecv(s.recv);
    }
  }
  if (ids) { AV.setPeers(ids); AV.setPolicy({ send: (id: string, kind: any) => sendPolicy(id, Sfu.sending(kind)), hear: heard }); }
}
